import {
	getBackgroundColorForSummaryTable,
	getProductGroupTotals,
	getUniqueAndCalculateSums
} from '@/components/rangePlan/utils';

const RangePlanReadOnlyTable = ({ rangePlanList }) => {
	const { departmentSums, fabricTypeSums, parentCategorySums } = getUniqueAndCalculateSums(rangePlanList);

	const productGroups = getProductGroupTotals(rangePlanList);

	return (
		<>
			<table className="table with-border hover scroll-x-label ">
				<thead>
					<tr>
						<th rowSpan={2} className="department-column">
							Dep.
						</th>
						<th colSpan={3}>Techpack & Sample Quantity</th>
						<th colSpan={4} className="price-range-column">
							Production Price Range
						</th>
						<th colSpan={2} className="buyer-column">
							Buyer
						</th>
					</tr>
					<tr className="sub-header-row">
						<th className="target-column primary">Target</th>
						<th className="techpack-column secondary">Techapck</th>
						<th className="sample-dev-column secondary">Sample Dev.</th>
						<th className="costed-column secondary">Costed</th>
						<th className="in-column secondary">In</th>
						<th className="consider-column secondary">Con.</th>
						<th className="out-column secondary">Out</th>
						<th className="presented-column secondary">Presented</th>
						<th className="selected-column secondary">Selected</th>
					</tr>
				</thead>
				<tbody>
					{Object.keys(productGroups).map((groupName) => {
						const group = productGroups[groupName];
						return (
							<>
								{/* Department total row */}
								<tr key={`group-${groupName}`} className="department-column">
									<td
										className="department-column"
										style={{
											backgroundColor: getBackgroundColorForSummaryTable(groupName)
										}}
									>
										<p className="gray_dark_01 semibold-14">{groupName}</p>
									</td>
									<td className="target-column">
										<p>{group?.targetQuantity}</p>
									</td>
									<td className="techpack-column">{group?.achievedQuantity}</td>
									<td className="sample-dev-column">
										<p>{group?.sampleDevelopedQuantity}</p>
									</td>
									<td className="costed-column">
										<p>{group?.totalCostedQuantity}</p>
									</td>
									<td className="in-column">
										<p>{group?.inRangeCount}</p>
									</td>
									<td className="consider-column">
										<p>{group?.inConsiderationCount}</p>
									</td>
									<td className="out-column">
										<p>{group?.outOfRangeCount}</p>
									</td>
									<td className="presented-column">
										<p>{group?.productPresentedQuantity}</p>
									</td>
									<td className="selected-column">
										<p>{group?.productSelectedQuantity}</p>
									</td>
								</tr>
							</>
						);
					})}
				</tbody>
			</table>

			<div className="depertment-wise-table shadow-4dp bg-white d-inline-block border ml-20">
				<p className="gray_dark_01 semibold-16 pb-4">
					Department wise <span className="weight-400">(Development complete)</span>
				</p>
				<div className="table-items d-grid">
					<div className="left-table">
						<table className="table with-border mb-0">
							<tbody>
								{Object.keys(departmentSums).map((department) => (
									<tr key={department}>
										<td className="department-column-2">
											<p className="gray_dark_01">{department}</p>
										</td>
										<td>
											<p className="gray_dark_01">{departmentSums[department]}</p>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="table-item">
						<table className="table with-border mb-0">
							<tbody>
								{Object.keys(fabricTypeSums).map((fabricType) => (
									<tr key={fabricType}>
										<td className="department-column">
											<p className="gray_dark_01">{fabricTypeSums[fabricType].name}</p>
										</td>
										<td>
											<p className="gray_dark_01">{fabricTypeSums[fabricType].total}</p>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					<table className="table with-border mb-0">
						<tbody>
							{Object.keys(parentCategorySums).map((category) => (
								<tr key={category}>
									<td className="department-column">
										<p className="gray_dark_01">{parentCategorySums[category].name}</p>
									</td>
									<td>
										<p className="gray_dark_01">{parentCategorySums[category].total}</p>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

export default RangePlanReadOnlyTable;
